import {
  UPLOAD_GEOGROUPS,
  UPLOAD_GEOGROUPS_RESULT,
  UPLOAD_GEOGROUPS_FAILED
} from '../actions/types';

export const geogroupsRequest = (state = {}, action) => {
  switch(action.type) {
    case UPLOAD_GEOGROUPS_RESULT:
      return Object.assign({}, state, {
        isFetching: false,
        result: action.payload
      });
    case UPLOAD_GEOGROUPS:
      return Object.assign({}, state, {
        isFetching: true,
      });
    case UPLOAD_GEOGROUPS_FAILED:
      return Object.assign({}, state, {
        isFetching: false,
        error: "error importing geogroups"
      });
    default: {
      return state;
    }
  }
}
